
import { defineComponent, PropType } from 'vue'
import { SubscribedPlanInfo } from '~/mixins/activeUserMixin'
import { featureMap, FeatureProperties, FeatureType, PlanTypes, V2PlanTypes } from '~/types/features'
import { getRequiredPlanName, SALES_URL } from '~/utils/billing'

export default defineComponent({
  name: 'PlanGateUpgradeInline',
  props: {
    feature: {
      type: String as PropType<FeatureType>,
      required: true
    },
    canChangePlan: {
      type: Boolean,
      required: true
    },
    planInfo: {
      type: Object as PropType<SubscribedPlanInfo>,
      default: () => ({})
    }
  },
  computed: {
    featureConfig(): FeatureProperties {
      return featureMap[this.feature]
    },
    planName(): string {
      return getRequiredPlanName(this.feature, this.planInfo)
    },
    isEnterpriseTier(): boolean {
      return this.featureConfig.minRequiredPlanV2 === V2PlanTypes.ENTERPRISE || this.featureConfig.minRequiredPlan === PlanTypes.ENTERPRISE
    },
    salesUrl(): string {
      return SALES_URL
    }
  }
})
